<template>
  <div v-if="!item.hidden">
    <el-menu-item v-if="isEmpty(item.children) && item.isFrame === '1'" :index="item.path" :route="item.path">
      <template #title>
        <a :href="item.path" @click="handleClick($event, item)">
          <cat-icon
            v-if="item.meta.icon"
            :name="`icon_${item.meta.icon}`"
            prefix="iconfont_menu"
            :style="menuIconStyle"
          ></cat-icon>
          <span>{{ item.meta.title }}</span>
        </a>
      </template>
    </el-menu-item>
    <!-- 外链点击跳转 -->
    <el-menu-item v-else-if="isEmpty(item.children) && item.isFrame === '0'">
      <template #title>
        <a :href="item.path" target="_blank">
          <cat-icon
            v-if="item.meta.icon"
            :name="`icon_${item.meta.icon}`"
            prefix="iconfont_menu"
            :style="menuIconStyle"
          ></cat-icon
          ><span>{{ item.meta.title }}</span></a
        >
      </template>
    </el-menu-item>
    <el-submenu v-else :index="item.path" popper-class="side-bar-popper">
      <template #title>
        <cat-icon
          v-if="item.meta.icon"
          :name="`icon_${item.meta.icon}`"
          prefix="iconfont_menu"
          :style="menuIconStyle"
        ></cat-icon>
        <span>{{ item.meta.title }}</span>
      </template>
      <side-bar-item v-for="child in item.children" :key="child.menuId" :item="child" />
    </el-submenu>
  </div>
</template>
<script lang="ts">
export default { name: 'SideBarItem' };
</script>
<script lang="ts" setup>
import { isEmpty } from 'lodash-es';
import type { IMenuItemProps } from './types.d';
const props = defineProps({
  item: {
    type: Object as PropType<IMenuItemProps>,
    required: true,
  },
});
const { item } = toRefs(props);
const appStore = useAppStore();
const { collapse } = storeToRefs(appStore);
const menuIconStyle = computed(() => {
  const iconStyle = 'font-size: 20px;vertical-align: -5px;';
  return collapse.value ? `${iconStyle}margin-right: 24px; ` : iconStyle;
});
const router = useRouter();
const handleClick = (e: MouseEvent, item: any) => {
  e.preventDefault();
  e.stopPropagation();
  if (e.ctrlKey || e.metaKey) {
    window.open(item.path, '_blank');
  } else {
    router.push(item.path);
  }
};
</script>
<style lang="scss" scoped>
:deep {
  .el-menu {
    background-color: transparent;
    user-select: none;
  }

  .el-submenu__title,
  .el-menu-item {
    color: white;
    margin-top: 8px;
    height: 40px;
    line-height: 40px;

    span {
      vertical-align: unset;
      padding: 0 10px;
    }

    &:hover,
    &:focus,
    &.is-active {
      background-color: $--color-primary;
      color: white;
    }
  }

  .el-submenu .el-menu-item {
    height: 40px;
    line-height: 40px;
  }

  .el-submenu__title i {
    color: white;
  }

  .el-icon-arrow-down::before {
    content: '\e790';
  }

  .el-icon-arrow-right {
    display: none;
  }

  a {
    display: block;
  }
}
</style>
<style lang="scss">
.side-bar-popper .el-menu--popup {
  background: #2c405a;
  padding: 4px 0;

  .el-menu-item {
    margin-top: 4px;
  }

  :first-child .el-menu-item {
    margin-top: 0;
  }
}
</style>
